/* Dear Forever · küçük yardımcılar (Horizon üzerine). */
(function () {
  var BADGE = (window.dfSettings && window.dfSettings.luxuryBadge) || 'Best for gifting';
  var MATCH = /luxury/i;

  function badgeLuxury(root) {
    (root || document).querySelectorAll('variant-picker input[type="radio"], swatches-variant-picker-component input[type="radio"]').forEach(function (inp) {
      if (!MATCH.test(inp.value || '')) return;
      var lab = inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null;
      if (!lab) lab = inp.closest('label') || inp.nextElementSibling;
      if (!lab || lab.querySelector('.df-lux')) return;
      lab.style.position = 'relative';
      var b = document.createElement('span');
      b.className = 'df-lux';
      b.textContent = BADGE;
      lab.appendChild(b);
    });
  }

  function peek(e) {
    var a = e.target.closest && e.target.closest('[data-df-peek]');
    if (!a) return;
    var t = document.querySelector('.df-card');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function init() {
    badgeLuxury();
    document.addEventListener('click', peek);
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes && list[i].addedNodes.length) { badgeLuxury(); break; }
      }
    });
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.querySelector('variant-picker, swatches-variant-picker-component')) mo.observe(s, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
